import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { WizardStyles } from "@/components/styles/WizardStyles";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Accordion, AccordionSummary, CircularProgress } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useGetOne } from "react-admin";
import { useQuery } from "@apollo/client";
import { CancelButton } from "../Tally/styles";
import { ListApprovalsMatches } from "./ListApprovalsMatches";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { getAttributeLabel } from "@/services/UserService";
import { USER_PROFILE_ATTRIBUTES } from "@/queries/GetUserProfileAttributes";
import { convertOneToSnakeCase, convertToCamelCase, convertToSnakeCase } from "./UtilsApprovals";
import { IApplicationsStatus } from "@/types/applications";
import { RejectApplicationButton, RejectApplicationDialog } from "./RejectApplication";
export var ViewApproval = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId, currApprovalId = _a.currApprovalId, goBack = _a.goBack, electionEventRecord = _a.electionEventRecord, _b = _a.isModal, isModal = _b === void 0 ? false : _b;
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var _c = useState(false), rejectDialogOpen = _c[0], setRejectDialogOpen = _c[1];
    var userAttributes = useQuery(USER_PROFILE_ATTRIBUTES, {
        variables: {
            tenantId: tenantId,
            electionEventId: electionEventId,
        },
    }).data;
    var _d = useGetOne("sequent_backend_applications", { id: currApprovalId }), task = _d.data, isLoading = _d.isLoading;
    if (!task || isLoading) {
        return _jsx(CircularProgress, {});
    }
    var renderDetails = function () {
        var _a;
        if (!task.applicant_data || typeof task.applicant_data !== "object") {
            return (_jsx(TableRow, { children: _jsx(TableCell, { colSpan: 2, children: t("common.noData") }) }));
        }
        var formatValue = function (value) {
            if (value === null || value === undefined) {
                return "-";
            }
            // Handle different data types
            if (value instanceof Date) {
                return value.toLocaleString();
            }
            if (typeof value === "boolean") {
                return value ? "Yes" : "No";
            }
            if (typeof value === "object") {
                return JSON.stringify(value);
            }
            return String(value);
        };
        var userApprovalInfo = Object.entries(convertToSnakeCase(task.applicant_data)).map(function (_a) {
            var key = _a[0], value = _a[1];
            return key;
        });
        if (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) {
            var applicantData = userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes.map(function (attr, index) {
                var _a;
                if (attr &&
                    attr.name &&
                    userApprovalInfo.includes(convertOneToSnakeCase(attr.name))) {
                    var key = getAttributeLabel((_a = attr["display_name"]) !== null && _a !== void 0 ? _a : attr.name);
                    var value = task.applicant_data[convertToCamelCase(attr.name)];
                    return (_jsxs(TableRow, { children: [_jsx(TableCell, { sx: {
                                    fontWeight: "500",
                                    width: "40%",
                                    textTransform: "capitalize",
                                }, children: t(key) }), _jsx(TableCell, { children: formatValue(value) })] }, index));
                }
                return null;
            });
            task.status === IApplicationsStatus.REJECTED &&
                applicantData.push(_jsxs(TableRow, { children: [_jsx(TableCell, { sx: {
                                fontWeight: "500",
                                width: "40%",
                                textTransform: "capitalize",
                            }, children: t("approvalsScreen.reject.rejectReason") }), _jsx(TableCell, { children: formatValue(t("approvalsScreen.reject.reasons.".concat((_a = task.annotations.rejection_reason) !== null && _a !== void 0 ? _a : "undefined"))) })] }, 100));
            return applicantData;
        }
        return [];
    };
    var Content = (_jsxs(_Fragment, { children: [_jsxs(Accordion, { sx: { width: "100%" }, expanded: true, children: [_jsx(AccordionSummary, { expandIcon: false, children: _jsx(WizardStyles.AccordionTitle, { children: t("approvalsScreen.approvalRequest") }) }), _jsx(WizardStyles.AccordionDetails, { sx: { marginBottom: "3rem" }, children: _jsx(TableContainer, { component: Paper, children: _jsx(Table, { "aria-label": "approvals details table", children: _jsx(TableBody, { children: renderDetails() }) }) }) }), task.status === IApplicationsStatus.PENDING && (_jsx(RejectApplicationButton, { label: String(t("approvalsScreen.reject.label")), onClick: setRejectDialogOpen }))] }), _jsx(ListApprovalsMatches, { electionEventId: electionEventId, electionId: electionId, task: task, goBack: goBack })] }));
    if (isModal) {
        return (_jsx(Dialog, { open: true, variant: "info", handleClose: goBack, title: String(t("approvalsScreen.taskInformation")), ok: String(t("approvalsScreen.ok")), fullWidth: true, maxWidth: "md", children: _jsx(_Fragment, { children: Content }) }));
    }
    return (_jsxs(WizardStyles.WizardContainer, { children: [_jsx(WizardStyles.ContentWrapper, { children: _jsx(WizardStyles.ContentBox, { children: Content }) }), _jsx(WizardStyles.FooterContainer, { children: _jsx(WizardStyles.StyledFooter, { children: _jsxs(CancelButton, { className: "list-actions", onClick: goBack, children: [_jsx(ArrowBackIosIcon, {}), t("common.label.back")] }) }) }), _jsx(RejectApplicationDialog, { electionEventId: electionEventId, task: task, goBack: goBack, rejectDialogOpen: rejectDialogOpen, setRejectDialogOpen: setRejectDialogOpen })] }));
};
